<template>
  <div class="banner">
    <div class="banner-container">
      <div class="banner-slider" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div 
          v-for="(item, index) in imgList" 
          :key="index" 
          class="banner-slide"
          :style="{ backgroundImage: `url(${baseUrl + item.busBannerImage})` }"
        >
          <div class="slide-overlay">
            <div class="slide-content">
              <h1 class="slide-title" data-aos="fade-up" data-aos-delay="200">
                {{ item.busBannerTitle || '燃源科技' }}
              </h1>
              <p class="slide-description" data-aos="fade-up" data-aos-delay="400">
                {{ item.busBannerDesc || '专业的互联网解决方案提供商' }}
              </p>
              <!-- <div class="slide-actions" data-aos="fade-up" data-aos-delay="600">
                <router-link to="/product" class="btn btn-primary">
                  查看案例
                </router-link>
                <router-link to="/about" class="btn btn-outline">
                  联系我们
                </router-link>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 轮播指示器 -->
      <div class="banner-indicators">
        <div 
          v-for="(item, index) in imgList" 
          :key="index"
          class="indicator"
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)"
        ></div>
      </div>

      <!-- 轮播控制按钮 -->
      <div class="banner-controls">
        <button class="control-btn prev" @click="prevSlide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="control-btn next" @click="nextSlide">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- 粒子背景 -->
      <div class="particles-container">
        <div class="particle" v-for="n in 20" :key="n"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBannerList } from '@/api/work/banner';

export default {
  name: "Banner",
  props: ["imgItem", "bannerHeight"],
  data() {
    return {
      currentIndex: 0,
      imgList: [],
      baseUrl: this.$baseUrl,
      imgHeight: window.innerHeight,
      autoplayInterval: null
    }
  },
  created() {
    this.getBannerList();
  },
  mounted() {
    this.startAutoplay();
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  },
  beforeDestroy() {
    this.stopAutoplay();
    window.removeEventListener('resize', this.updateHeight);
  },
  methods: {
    getBannerList() {
      getBannerList().then(res => {
        this.imgList = res.data;
      })
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.imgList.length;
    },
    prevSlide() {
      this.currentIndex = this.currentIndex === 0 ? this.imgList.length - 1 : this.currentIndex - 1;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
    },
    updateHeight() {
      this.imgHeight = window.innerHeight;
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin-top: 0;
  padding-top: 80px;
  box-sizing: border-box;

  .banner-container {
    width: 100%;
    height: calc(100vh - 80px);
    position: relative;
  }

  .banner-slider {
    width: 100%;
    height: calc(100vh - 80px);
    display: flex;
    transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .banner-slide {
    min-width: 100%;
    height: calc(100vh - 80px);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(10, 25, 41, 0.8) 0%, rgba(19, 47, 76, 0.6) 100%);
    }
  }

  .slide-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .slide-content {
    text-align: center;
    max-width: 800px;
    padding: 0 24px;
    color: white;
  }

  .slide-title {
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 700;
    margin-bottom: 24px;
    background: linear-gradient(135deg, #ffffff 0%, #b2bac2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.2;
  }

  .slide-description {
    font-size: clamp(1rem, 2vw, 1.25rem);
    margin-bottom: 32px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
  }

  .slide-actions {
    display: flex;
    gap: 16px;
    justify-content: center;
    flex-wrap: wrap;

    .btn {
      padding: 12px 32px;
      border-radius: 8px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s ease;
      }

      &:hover::before {
        left: 100%;
      }
    }

    .btn-primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba(102, 126, 234, 0.6);
      }
    }

    .btn-outline {
      background: transparent;
      color: white;
      border: 2px solid rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(10px);

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.5);
        transform: translateY(-2px);
      }
    }
  }

  .banner-indicators {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 3;

    .indicator {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.6);
        transform: scale(1.2);
      }

      &.active {
        background: #667eea;
        transform: scale(1.3);
        box-shadow: 0 0 20px rgba(102, 126, 234, 0.6);
      }
    }
  }

  .banner-controls {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    z-index: 3;

    .control-btn {
      width: 48px;
      height: 48px;
      border: none;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      color: white;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.1);
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  .particles-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1;

    .particle {
      position: absolute;
      width: 4px;
      height: 4px;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 50%;
      animation: float 6s ease-in-out infinite;

      &:nth-child(1) { left: 10%; top: 20%; animation-delay: 0ms; animation-duration: 4000ms; }
      &:nth-child(2) { left: 20%; top: 80%; animation-delay: 500ms; animation-duration: 5000ms; }
      &:nth-child(3) { left: 30%; top: 40%; animation-delay: 1000ms; animation-duration: 6000ms; }
      &:nth-child(4) { left: 40%; top: 60%; animation-delay: 1500ms; animation-duration: 4500ms; }
      &:nth-child(5) { left: 50%; top: 10%; animation-delay: 2000ms; animation-duration: 5500ms; }
      &:nth-child(6) { left: 60%; top: 70%; animation-delay: 2500ms; animation-duration: 4800ms; }
      &:nth-child(7) { left: 70%; top: 30%; animation-delay: 3000ms; animation-duration: 5200ms; }
      &:nth-child(8) { left: 80%; top: 90%; animation-delay: 3500ms; animation-duration: 4700ms; }
      &:nth-child(9) { left: 90%; top: 50%; animation-delay: 4000ms; animation-duration: 5300ms; }
      &:nth-child(10) { left: 15%; top: 85%; animation-delay: 4500ms; animation-duration: 4900ms; }
      &:nth-child(11) { left: 25%; top: 15%; animation-delay: 5000ms; animation-duration: 5400ms; }
      &:nth-child(12) { left: 35%; top: 75%; animation-delay: 5500ms; animation-duration: 4600ms; }
      &:nth-child(13) { left: 45%; top: 25%; animation-delay: 6000ms; animation-duration: 5100ms; }
      &:nth-child(14) { left: 55%; top: 65%; animation-delay: 6500ms; animation-duration: 4800ms; }
      &:nth-child(15) { left: 65%; top: 35%; animation-delay: 7000ms; animation-duration: 5200ms; }
      &:nth-child(16) { left: 75%; top: 95%; animation-delay: 7500ms; animation-duration: 4700ms; }
      &:nth-child(17) { left: 85%; top: 5%; animation-delay: 8000ms; animation-duration: 5300ms; }
      &:nth-child(18) { left: 95%; top: 55%; animation-delay: 8500ms; animation-duration: 4900ms; }
      &:nth-child(19) { left: 5%; top: 45%; animation-delay: 9000ms; animation-duration: 5400ms; }
      &:nth-child(20) { left: 95%; top: 85%; animation-delay: 9500ms; animation-duration: 4600ms; }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .banner {
    height: calc(100vh - 60px);
    padding-top: 60px;

    .banner-container,
    .banner-slider,
    .banner-slide {
      height: calc(100vh - 60px);
    }

    .slide-actions {
      flex-direction: column;
      align-items: center;

      .btn {
        width: 200px;
      }
    }

    .banner-controls {
      padding: 0 16px;

      .control-btn {
        width: 40px;
        height: 40px;
      }
    }

    .banner-indicators {
      bottom: 20px;
    }
  }
}
</style>
